import { optCollection } from './BasicOperate';
import { dispatch, getState } from '@@/store';
import React from 'react';
import { showInitiateDispute, showAbortiveAuction, showContract, showDaYuDispute, } from '@/shared/utils';
import { Modal, Icon } from 'antd';
export function waitPayCarColumn(props) {
    const { pageIdentification, record, orderCallback } = props;
    switch (Number(record.confirmReceivables)) {
        case 1:
            return null;
        default:
            return optCollection({
                pageIdentification,
                record,
                // 争议
                disputeClick: () => {
                    opt.handleDispute(record, orderCallback);
                },
                // 流拍
                passInClick: () => {
                    opt.handleAbortiveAuction(record, orderCallback);
                },
                // 查看合同
                viewContractClick: () => {
                    opt.watchContract(record, orderCallback);
                },
                // 申请财务付款
                applyFinancialCollectionClick: () => {
                    opt.handlePayConfirm(record, orderCallback);
                },
                // 出价详情
                bidDetailsCilck: () => {
                    dispatch.router.push({
                        path: '/carManage/offerdetails',
                        query: {
                            id: record.auctionId,
                        },
                    });
                },
            });
    }
}
// 处理争议
const opt = {
    updateTable(index) {
        dispatch.waitPayCar.updateTable(index);
        dispatch.winBiddingCar.getOrderCountInfoApi({});
    },
    commonUpdateTable() {
        const { pageCurrent, tableData } = getState().transfer;
        const tableDataLength = tableData.length - 1;
        if (pageCurrent !== 1) {
            if (tableDataLength === 0) {
                this.updateTable(pageCurrent - 1);
            }
            else {
                this.updateTable(pageCurrent);
            }
        }
        else {
            this.updateTable(pageCurrent);
        }
    },
    // 处理争议
    handleDispute(record, orderCallback) {
        dispatch.initiateDispute.passData({ actionType: record.actionType, orderTag: record.orderTag });
        if (record.actionType === 10 && record.orderTag === 1) {
            showDaYuDispute({
                data: record,
                callback: () => {
                    orderCallback ? orderCallback() : this.commonUpdateTable();
                },
            });
        }
        else {
            showInitiateDispute({
                data: record,
                lubanType: 1,
                callback: () => {
                    orderCallback ? orderCallback() : this.commonUpdateTable();
                },
            });
        }
    },
    // 处理流拍
    handleAbortiveAuction(record, orderCallback) {
        showAbortiveAuction({
            data: record,
            stateTip: '待付款',
            callback: () => {
                orderCallback ? orderCallback() : this.commonUpdateTable();
            },
        });
    },
    // 付款确认
    handlePayConfirm(record, orderCallback) {
        Modal.confirm({
            icon: <Icon type="exclamation-circle" theme="filled"/>,
            title: '是否确认申请财务收款？',
            okText: '确认',
            onOk() {
                dispatch.waitPayCar.applyPayMoney(record).then(() => {
                    if (orderCallback) {
                        orderCallback();
                    }
                    else {
                        const { pageCurrent, tableData } = getState().transfer;
                        const tableDataLength = tableData.length - 1;
                        if (pageCurrent !== 1) {
                            if (tableDataLength === 0) {
                                dispatch.waitPayCar.updateTable(pageCurrent - 1);
                            }
                            else {
                                dispatch.waitPayCar.updateTable(pageCurrent);
                            }
                        }
                        else {
                            dispatch.waitPayCar.updateTable(pageCurrent);
                        }
                    }
                });
            },
        });
    },
    // 查看合同
    watchContract(record, orderCallback) {
        showContract({
            orderId: record.orderId,
        });
    },
};
